import type { CatalogueProductAttributes } from 'src/graphql/generated';

type BudgetProductLineItem = Pick<
  CatalogueProductAttributes,
  'productId' | 'productSetId'
> & {
  type: 'Budget';
};

type MappedAdProductLineItem = Pick<
  CatalogueProductAttributes,
  'jobId' | 'revisionId' | 'productId' | 'productSetId'
>;
type AdProductLineItem = {
  [K in keyof MappedAdProductLineItem]-?: NonNullable<
    MappedAdProductLineItem[K]
  >;
} & {
  type: 'AdProduct';
};

type AdProductUpgradeLineItem = {
  [K in keyof MappedAdProductLineItem]-?: NonNullable<
    MappedAdProductLineItem[K]
  >;
} & {
  type: 'AdProductUpgrade';
};

export type CartLineItem =
  | AdProductLineItem
  | BudgetProductLineItem
  | AdProductUpgradeLineItem;

export const isAdProductLineItem = (
  cartLineItem: CartLineItem,
): cartLineItem is AdProductLineItem => cartLineItem.type === 'AdProduct';

export const isAdProductUpgradeLineItem = (
  cartLineItem: CartLineItem,
): cartLineItem is AdProductUpgradeLineItem =>
  cartLineItem.type === 'AdProductUpgrade';

export interface Cart {
  lineItems: CartLineItem[];
  orderId: string | null;
  promoCode?: string;
}
